// @core/api/endpoints/team/pause_role_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PauseRoleScheduleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Pause role schedule
 * Performs pause operation on role schedule.
 */
export async function PauseRoleSchedule(
  team_id: string,
  schedule_id: string,
  data: PauseRoleScheduleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id/pause`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
